const isNonSelectableCity = (region) => !region.cityCode || !region.cityName

const shouldIncludeRegion = (region, index) => index === 0 || !isNonSelectableCity(region)

const shouldAppendNearbyAirports = (region, index) => index === 0 && region.nearbyAirports?.length

const formatNearbyAirport = (nearbyAirport) => ({ ...nearbyAirport, type: 'NESTED_NEARBY_AIRPORT' })

const formatNonSelectableCity = (city) => ({ ...city, type: 'NON_SELECTABLE_CITY' })

const sortByScore = (a, b) => b.score - a.score

const formatResponse = (matchedRegions) => {
  const typeahead = []
  matchedRegions.forEach((region, index) => {
    if (shouldIncludeRegion(region, index)) {
      typeahead.push(isNonSelectableCity(region) ? formatNonSelectableCity(region) : region)
    }
    if (shouldAppendNearbyAirports(region, index)) {
      typeahead.push(
        ...region.nearbyAirports
          .filter((na) => na.country === region.countryCode)
          .sort(sortByScore)
          .slice(0, 4)
          .map(formatNearbyAirport)
      )
    }
  })
  return typeahead
}

export { formatResponse }
